import { Grid, TextField, Tooltip } from '@mui/material';
import React from 'react'
import styles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import Required from '../../../../../utility/required';
import InfoIcon from '@mui/icons-material/Info';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';

const CreateVariableFields = () => {
    const flagUpdateFieldData = useFlowBuilderStore((state) => state.flagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const setCreateCustomVariablePayload = useFlowBuilderStore((state) => state.setCreateCustomVariablePayload)
    const createCustomVariablePayload = useFlowBuilderStore((state) => state.createCustomVariablePayload)

    const handleChangeFieldDataPayload = (field_name: string, value: string) => { 
        let sanitizedValue = value;
        if(field_name == "chatbot_custom_variable_name"){
            sanitizedValue = value.replace(/[^a-zA-Z0-9_-]/g, '');
        }

        if (flagUpdateFieldData) {
            setExistingCustomVariablePayload({ ...existingCustomVariablePayload, [field_name]: sanitizedValue })
        }
        else {
            let updatedData = { ...createCustomVariablePayload, [field_name]: sanitizedValue }
            setCreateCustomVariablePayload(updatedData)
        }
    }

    return (
        <Grid item sx={{ width: "100%" }}>
            <Grid container direction={"column"} gap={"15px"}>
                <Grid item sx={{ width: "100%" }}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={styles.createWorkflowLabelStyle} sx={{ display: "flex", flexWrap: "nowrap" }} alignItems={"center"}>
                            Field Name <Required />
                            <Tooltip title={"Special characters and white-space are not allowed"}>
                                <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer", display: "flex" }} />
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <TextField
                                placeholder='Enter field name'
                                className={styles.createGlobalTextField}
                                value={flagUpdateFieldData ? existingCustomVariablePayload.chatbot_custom_variable_name : createCustomVariablePayload.chatbot_custom_variable_name}
                                onChange={(e) => handleChangeFieldDataPayload("chatbot_custom_variable_name", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item sx={{ width: "100%" }}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={styles.createWorkflowLabelStyle}>Fallback Value <Required /></Grid>
                        <Grid item>
                            <TextField
                                placeholder='Enter fallback value of field'
                                className={styles.createGlobalTextField}
                                value={flagUpdateFieldData ? existingCustomVariablePayload.chatbot_custom_variable_fallback_value : createCustomVariablePayload.chatbot_custom_variable_fallback_value}
                                onChange={(e) => handleChangeFieldDataPayload("chatbot_custom_variable_fallback_value", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default CreateVariableFields